import { Spinner } from "react-bootstrap"

interface LoadingTableWrapperProps {
  loading: boolean
  variant?: "dark" | "light" | "page"
  hideContent?: boolean
  withBorder?: boolean
  withHeader?: boolean
  children: React.ReactNode
}

function LoadingTableWrapper({
  loading,
  variant = "dark",
  hideContent = false,
  withBorder = true,
  withHeader = false,
  children,
}: LoadingTableWrapperProps) {
  const cssClasses = ["loading-table-wrapper"]
  if (loading && hideContent && withBorder) {
    cssClasses.push("with-border")
  }
  if (loading && variant === "page") {
    cssClasses.push("page")
  }

  return (
    <div className={cssClasses.join(" ")}>
      {loading && hideContent && <div className="invisible">{children}</div>}
      {loading && !hideContent && children}
      {loading && (
        <div className={`dimming-panel ${variant}`}>
          <Spinner className={`spinner ${withHeader ? "mt-5" : ""}`} animation="border" variant="secondary" />
        </div>
      )}
      {!loading && children}
    </div>
  )
}

export default LoadingTableWrapper
